import { axios } from '/plugins/axios.client';
import { errorFromResponse } from '/src/common/general-utils';
import { i18n } from '/plugins/i18n.client';
const errorHandler = errorFromResponse(i18n.global.t.bind(i18n));
import { toast } from '/plugins/toaster.client.js';

/**
 * Fetch url details
 * @param {String} url url for which details need to fetched
 * @returns {Object}
 */
export const getUrlDetails = async (url, checkTemplate) => {
  let urlDetails;
  try {
    urlDetails = await axios.$get(`/api/url/details`, {
      params: {
        url: `/${url.trim()}`,
        checkTemplate
      }
    });
    if (urlDetails.menuContent.items) {
      let [menuItem] = urlDetails.menuContent.items;
      if (menuItem) {
        urlDetails.targetUrl = menuItem.to;
      }
    }
  } catch (error) {
    toast.error(errorHandler('common.common_messages.retrieve_page', error));
    throw error;
  }
  return urlDetails;
};

export const getApplicationRedirectionUrl = async (application) => {
  try {
    if (!application.RedirectToMenu) {
      return await getRedirectionURL(application.urlJSON);
    }
    let response = await axios.$get(`/api/appManager/get-application-redirection-url/${application.UUID}`);
    if (!response) {
      return await getRedirectionURL(application.urlJSON);
    }
    return { url: response.to };
  } catch (e) {
    toast.error(errorHandler('common.common_messages.error_in_redirect', e));
    return { url: '' };
  }
};

export const getRedirectionURL = async (urlJSON) => {
  if (urlJSON.linkType === 'Custom') {
    if (!urlJSON.state) {
      return { url: '' };
    }
    let protocolRegex = /^(?:[a-z]+:)?\/\//i;
    // If it is as complete URL with the protocol then simply redirect to that
    if (protocolRegex.test(urlJSON.state)) {
      // Setting isExternalURL so that the caller can determine if it needs to be pushed in state ot href
      return { url: urlJSON.state, isExternalURL: true };
    }
    return { url: modifyURL(urlJSON.state) };
  }
  try {
    let { url } = await axios.$get(`/api/url/${urlJSON.UUID}`, {
      params: {
        feature: urlJSON.linkType
      }
    });
    url = modifyURL(url);
    if (urlJSON.linkType === 'Form Wizard') {
      url = `/wizard${url}/add`;
    }
    return { url };
  } catch (e) {
    toast.error(errorHandler('common.common_messages.retrieve_page', e));
    return { url: '' };
  }
};

const modifyURL = (url) => {
  // Replace /# or #
  url = url.replace(/\/#|#/, '').trim();
  // Prepend / if not available at first position
  if (url.indexOf('/') !== 0) {
    url = `/${url}`;
  }
  return url;
};

/**
 * This function helps in filtering whether it is a valid urlJSON or not
 * @param {Object} urlJSON UrlJSON object
 */
export const containsURL = (urlJSON) => urlJSON && urlJSON.state;
